import { memo, useMemo } from 'react'
import { List, Map } from 'immutable'
import InlineSelect from '@aytm/lib/rfd-ui/components/basic/inline-select'

import useComponentLayout from '../../states/useComponentLayout'
import useSelectedItems from '../../states/useSelectedItems'

import { ROW_PADDING } from '../../config/CompareItems_const'

import { CompareItemsTableAddItemCell as TCompareItemsTableAddItemCell } from '../../types'

import style from './AddItemCell.module.scss'

export default memo(
  CompareItemsTableAddItem,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableAddItem({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableAddItemCell
}) {
  const componentLayout = useComponentLayout()
  const dataHeight = componentLayout.measures.dataHeight

  const selectedItems = useSelectedItems()

  const fetchItemOptions = useMemo(
    () => (filterValue: string) =>
      List(
        cell.items
          .map((item, itemIndex) =>
            !filterValue || item.text.toLowerCase().includes(filterValue.toLowerCase())
              ? Map({
                  value: itemIndex,
                  render: () => (
                    <>
                      <b className={style.selector__option__item_name}>
                        {cell.itemName} {item.position}.
                      </b>
                      <br />
                      {item.text}
                    </>
                  )
                })
              : null
          )
          .filter(item => Boolean(item))
      ),
    [cell.items, cell.itemName]
  )

  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableAddItem}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
      data-compare-items="add-item-cell"
    >
      <InlineSelect
        fetchOptions={fetchItemOptions}
        onSelect={(option: Map<string, number | (() => JSX.Element)>) => {
          const itemIndex = option.get('value') as number
          if (null != itemIndex) {
            selectedItems.addItem(itemIndex)
          }
        }}
        className={style.selector}
        value={null}
        maxHeight={Math.max(dataHeight + ROW_PADDING, 100)}
        filter={cell.items.length > 9}
      >
        Choose another {cell.itemName}
      </InlineSelect>
    </div>
  )
}
